module.exports = __webpack_public_path__ + "img/efset-score01.6cb9002f.jpg";